
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  computed,
  defineComponent, inject, onMounted, reactive, watch,
} from 'vue';
import {
  Form, InputNumber, Select, Button, Input, Checkbox, message,
} from 'ant-design-vue';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons-vue';
import Editor from '@/components/Editor.vue';
import WangEditor from 'wangeditor';
import { uniqBy, uniqueId } from 'lodash';
import asynButtonVue from '@/components/asynButton.vue';
import { ParseQuestionI } from './js/interface';

export default defineComponent({
  name: 'Multiple',
  components: {
    Editor,
    aForm: Form,
    aFormItem: Form.Item,
    aInput: Input,
    aInputNumber: InputNumber,
    aTextArea: Input.TextArea,
    aSelect: Select,
    aOption: Select.Option,
    aCheckbox: Checkbox,
    aCheckboxGroup: Checkbox.Group,
    PlusOutlined,
    DeleteOutlined,
    aButton: asynButtonVue,
  },
  emits: ['emit-validate'],
  setup(props, { emit }) {
    const dataClone = inject('dataClone') as ParseQuestionI;

    watch(() => dataClone, (data) => {
      Object.assign(dataClone, data);
    }, { deep: true });

    const handleAddMetaClick = () => {
      dataClone.pMetas.push({
        uid: uniqueId(),
        meta: '',
      });
    };

    const handleDelMetaClick = (metaIndex: number) => {
      dataClone.pMetas.splice(metaIndex, 1);
    };

    const isChecked = (metaIndex: number) => dataClone.pAnswer.findIndex((d: any) => d === metaIndex) > -1;

    const handleCheckboxChange = (metaIndex: number) => {
      const i = (dataClone.pAnswer as number[]).indexOf(metaIndex);
      if (isChecked(metaIndex)) {
        (dataClone.pAnswer as number[]).splice(i, 1);
      } else {
        (dataClone.pAnswer as number[]).push(metaIndex);
      }
    };

    const reachMaxLimit = computed(() => dataClone.pMetas.length >= 4);

    const stemEditor = reactive({}) as WangEditor;
    const analyEditor = reactive({}) as WangEditor;
    const validate = () => {
      // if (!stemEditor.txt.text().length) {
      //   message.error('题目输入字数不满足限制，请重新输入！');
      //   return false;
      // }
      if (dataClone.stem.length > 100 || dataClone.stem.length <= 0) {
        message.error('题目字数为1~100！');
        return false;
      }
      if (dataClone.pMetas.some((d) => !d.meta.length)) {
        message.error('选项输入字数不满足限制，请重新输入！');
        return false;
      }
      if (dataClone.pMetas.length < 2) {
        message.error('请输入至少两个选项！');
        return false;
      }
      if (uniqBy(dataClone.pMetas, 'meta').length !== dataClone.pMetas.length) {
        message.error('选项内容不能重复！');
        return false;
      }
      if (!dataClone.pAnswer.length || Number.isNaN(dataClone.pAnswer[0])) {
        message.error('请选择答案！');
        return false;
      }
      if (dataClone.pAnswer.length < 2) {
        message.error('请至少选择2个答案');
        return false;
      }
      if (!analyEditor.txt.text().length) {
        message.error('解析输入字数不满足限制，请重新输入！');
        return false;
      }
      if (analyEditor.txt.text().length > 2000) {
        message.error('解析最多输入2000字数！');
        return false;
      }
      return true;
    };

    onMounted(() => {
      if (!dataClone.pAnswer.length) dataClone.pAnswer = [];
      emit('emit-validate', validate);
    });

    const onEditorMounted = (index: number, editor: WangEditor) => {
      if (index === 0) Object.assign(stemEditor, reactive(editor) as WangEditor);
      if (index === 1) Object.assign(analyEditor, reactive(editor) as WangEditor);
    };

    return {
      dataClone,
      isChecked,
      reachMaxLimit,
      handleAddMetaClick,
      handleDelMetaClick,
      handleCheckboxChange,
      onEditorMounted,
    };
  },
});
